import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import classNames from 'clsx';
import React from 'react';

import styles from './SkeletonTable.scss';

const SkeletonTable: React.FC<{
  countRows: number;
  countColumns: number;
  tableWidth: number;
}> = ({ countRows, countColumns, tableWidth }) => (
  <div>
    <div className={styles.skeletonContainer}>
      {Array.from({ length: countColumns }, (_, index) => (
        <Skeleton
          key={index}
          variant="rect"
          height={65}
          width="21%"
          animation="wave"
          className={classNames(styles.skeleton, styles.skeletonColumn)}
        />
      ))}
    </div>
    {Array.from({ length: countRows }, (_, index) => (
      <div
        key={index}
        className={classNames(styles.skeletonContainer, {
          [styles.singleTable]: tableWidth === 100
        })}
      >
        <Skeleton
          variant="rect"
          height={30}
          width={`${tableWidth}%`}
          animation="wave"
          className={classNames(styles.skeleton, styles.skeletonRow)}
        />
        {tableWidth === 70 && (
          <Skeleton
            variant="rect"
            height={30}
            width="30%"
            animation="wave"
            className={classNames(styles.skeleton, styles.skeletonRow)}
          />
        )}
      </div>
    ))}
  </div>
);

export default SkeletonTable;
